// A super admin opening an agent's or ISO's portal as them (backend
// resolvers/iso.js viewAsAgent): the admin's own login is kept aside under
// BACKUP_KEY while the agent's 2-hour login sits in 'user-enatega', and
// "Back to admin" (layouts/Agent.jsx) puts it back.

const USER_KEY = 'user-enatega'
const BACKUP_KEY = 'rmf-admin-view-as'
const RETURN_PATH = '#/super_admin/agents'

function read(key) {
  try {
    return JSON.parse(localStorage.getItem(key))
  } catch (e) {
    return null
  }
}

/** Switch this tab to the agent's portal, keeping the admin's login aside. */
export function startViewAs(session) {
  const admin = localStorage.getItem(USER_KEY)
  // Viewing as someone else while already viewing: keep the first, real, admin login.
  if (!read(BACKUP_KEY)) localStorage.setItem(BACKUP_KEY, JSON.stringify({ user: admin }))
  localStorage.setItem(USER_KEY, JSON.stringify({
    userId: session.userId,
    userType: session.userType,
    email: session.email,
    name: session.name,
    token: session.token,
    viewAs: { expiresAt: session.expiresAt },
  }))
  window.location.hash = '#/agent/home'
  window.location.reload()
}

/** { name, email, expiresAt } while a super admin is viewing as an agent, else null. */
export function viewAsInfo() {
  const user = read(USER_KEY)
  if (!read(BACKUP_KEY) || !user || !user.viewAs) return null
  return { name: user.name, email: user.email, expiresAt: user.viewAs.expiresAt }
}

/** Back to the admin's own login and the ISOs & Agents page. */
export async function exitViewAs(client) {
  const backup = read(BACKUP_KEY)
  if (backup && backup.user) localStorage.setItem(USER_KEY, backup.user)
  else localStorage.removeItem(USER_KEY)
  localStorage.removeItem(BACKUP_KEY)
  try { if (client) await client.clearStore() } catch (e) { /* nothing cached */ }
  window.location.hash = RETURN_PATH
  window.location.reload()
}
